<template>
  <article class="NotePush">
    <div class="NotePush_wrapper">

      <img class="NotePush_shape" src="../../public/static/images/shape-cyan-big.svg" ref='shape' v-if="data.illustration"/>

      <figure class="NotePush_illustration" v-if="data.illustration">
        <div class="NotePush_illustration_image NotePush_illustration_image_bodymovin" v-if="data.illustration.endsWith('.json')" ref="bodymovin"></div>
        <img class="NotePush_illustration_image" :src="data.illustration" v-else/>
      </figure>

      <div class="NotePush_content">
        <h3 class="NotePush_subtitle" v-if="data.sur_titre">{{ data.sur_titre }}</h3>
        <h4 class="NotePush_title" v-if="data.titre" v-html="data.titre"></h4>
        <div class="NotePush_text" v-if="data.contenu" v-html="data.contenu"></div>
      </div>

    </div>
  </article>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'
  import lottie from 'lottie-web'

  export default {
    name: "NotePush",
    props: [ 'data' ],
    mixins: [ scrollUpdate ],
    data() {
      return {
        anim: null
      }
    },
    methods: {
      onVisible()
      {
        if(this.anim)
          this.anim.play()
      },
      onUnVisible()
      {
        if(this.anim)
          this.anim.pause()
      }
    },
    mounted()
    {
      if(this.$refs.shape)
        this.$scroll.set(this.$refs.shape, { y: -25 }, { y: 0 }, { y: -50 }, null, -0.6)

      if(this.data.illustration && this.data.illustration.endsWith(".json"))
      {
        this.anim = lottie.loadAnimation({
          container: this.$refs.bodymovin,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          path: this.data.illustration
        });
      }

      // if(this.$tools.isMobile())
      // {
      //   this.$scroll.set(this.$el, { y: 0, opacity: 1 }, { y: 60, opacity: 0.5 }, { y: 0, opacity: 1 })
      // }
    }
  }
</script>

<style lang="stylus">
.NotePush

  position relative
  width 100%
  border-bottom 1px solid #E8E9F0
  overflow hidden

  @media $medium

    border-bottom 0px
    overflow visible

  &_wrapper

    display flex
    flex-direction row
    flex-wrap wrap
    align-items center
    justify-content center
    width 100%
    padding 70px 0px

    @media $medium

      flex-direction column

  &_shape

    position absolute
    top -10%
    left 0px
    width 50%
    z-index -1

    @media $small

      width 90%
      left -10%

  &_illustration 
    
    width 100%
    max-width 390px
    position relative
    display block
    margin auto
    
    &_image

      width 100%

  &_content

    text-align: center;
    max-width 390px
    width 100%
    margin auto auto

  &_subtitle

    font-family: $f-title
    font-weight normal
    font-size: 14px;
    color: $red;
    letter-spacing: 0;
    line-height: 20px;
    text-transform uppercase
    margin 0px auto
    margin-bottom 20px

  &_title

    font-family: $f-title
    font-weight 500
    font-size: 24px;
    color: $blue
    letter-spacing: -0.3px;
    line-height: 30px;
    margin 0px auto
    margin-bottom 20px

    @media $small

      font-size 20px
      line-height 24px

  &_text

    font-family: $f-content
    font-size: 16px;
    color: $blue
    letter-spacing: 0;
    line-height: 24px;
    margin 0px

    a

      color $blue
      text-decoration underline


.ie 

  .NotePush

    &_wrapper

      flex-direction column
      align-items center
      justify-content center

    &_content, &_illustration

      margin auto auto
</style>